import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import app from 'flarum/forum/app';

import { loadAlts, rememberAlt } from '../altsStore';

/**
 * Create or rename an alt. One modal for both because the fields are identical
 * and the difference is only which request gets sent.
 */
export default class AltModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.alt = this.attrs.alt || null;

    this.username = Stream(this.alt ? this.alt.username() : '');
    this.nickname = Stream(this.alt && this.alt.nickname ? this.alt.nickname() || '' : '');
  }

  className() {
    return 'AltModal Modal--small';
  }

  title() {
    return this.alt
      ? app.translator.trans('nurriemunchers-alts.forum.modal.rename_title', { username: this.alt.displayName() })
      : app.translator.trans('nurriemunchers-alts.forum.modal.create_title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form-group">
          <label>{app.translator.trans('nurriemunchers-alts.forum.modal.username_label')}</label>
          <input
            className="FormControl"
            bidi={this.username}
            disabled={this.loading}
            maxlength="30"
            autocomplete="off"
          />
          <p className="helpText">{app.translator.trans('nurriemunchers-alts.forum.modal.username_help')}</p>
        </div>

        <div className="Form-group">
          <label>{app.translator.trans('nurriemunchers-alts.forum.modal.nickname_label')}</label>
          <input className="FormControl" bidi={this.nickname} disabled={this.loading} autocomplete="off" />
          <p className="helpText">{app.translator.trans('nurriemunchers-alts.forum.modal.nickname_help')}</p>
        </div>

        <div className="Form-group">
          <Button className="Button Button--primary Button--block" type="submit" loading={this.loading}>
            {app.translator.trans('nurriemunchers-alts.forum.modal.submit_button')}
          </Button>
        </div>
      </div>
    );
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    const attributes = {
      username: this.username(),
      nickname: this.nickname() || null,
    };

    const request = this.alt
      ? app.request({
          method: 'PATCH',
          url: app.forum.attribute('apiUrl') + '/alts/' + this.alt.id(),
          body: { data: { attributes } },
        })
      : app.request({
          method: 'POST',
          url: app.forum.attribute('apiUrl') + '/alts',
          body: { data: { attributes } },
        });

    request
      .then((payload) => {
        app.store.pushPayload(payload);

        const user = app.store.getById('users', payload.data.id);
        if (user) rememberAlt(user);

        return loadAlts(true);
      })
      .then(() => {
        this.hide();
      })
      .catch(() => {
        this.loading = false;
        m.redraw();
      });
  }
}
